import React from 'react'
import NewSkeleton from './NewSkeleton'
import OldSkeleton from './OldSkeleton'
import { useCommonCMSConfig } from '~api'

function SkeletonFiat() {
    const { newSendFiatFlow } = useCommonCMSConfig().data?.features ?? {}

    if (newSendFiatFlow) {
        return <NewSkeleton />
    }

    return <OldSkeleton />
}

export default SkeletonFiat
